import React from 'react';
import { Typography, Box, useTheme } from "@mui/material";
import { tokens } from "../theme";


const Header = ({ title }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box display="flex" justifyContent="space-between" alignItems="center" mb="5px">
      <Box>
        <Typography
          variant="h4"
          color={colors.grey[100]}
          fontWeight="bold"
          sx={{ m: "0 0 2px 0" }}
        >
          {title}
        </Typography>
      </Box>
    </Box>
  );
};

export default Header;
